module.exports = __webpack_public_path__ + "static/img/1_5_1.8b4ea85d.jpg";